import CustForm from "../components/CustForm";
export function AdminAllEnrolled() {

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Всички записани</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Всички записани</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <CustForm />
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminAllEnrolled;